import { memo } from 'react';
import { getDisplayName, getFullDisplayName } from '../../../helpers/Appointment';
import { BaseAppointmentNameProps } from './BaseAppointmentName.types';

/**
 * The base component for displaying the appointment name.
 *
 * This component decides whether to display the full name or just the display name based on the `fullName` prop.
 * It also supports displaying the last name first if the `lastFirst` prop is set to true.
 *
 * @param appointment - {@link BaseAppointmentNameProps.appointment appointment} description.
 * @param fullName - {@link BaseAppointmentNameProps.appointment fullName} description.
 * @param lastFirst - {@link BaseAppointmentNameProps.appointment lastFirst} description.
 */
export const BaseAppointmentName = memo(({
    appointment,
    fullName,
    lastFirst,
}: BaseAppointmentNameProps) => {
    return (
        <>
            {fullName ? (
                getFullDisplayName(appointment, lastFirst)
            ) : (
                getDisplayName(appointment)
            )}
        </>
    );
});